import React from 'react';
import { Heading, PrimaryButton, SecondaryButton } from '../../../components';
import css from './SectionHero.module.css';
import sectionHeroVideo from './sectionHeroVideo.mp4';

function SectionHero(props) {
  const { useHistoryPush, intl, isAuthenticated } = props;

  const title = intl.formatMessage({ id: 'SectionHero.title' });
  const description = intl.formatMessage({ id: 'SectionHero.description' });
  const explore = intl.formatMessage({ id: 'SectionHero.exploreNow' });
  const joinLabel = intl.formatMessage({ id: 'SectionHero.joinNow' });

  return (
    <div className={css.heroWrapper}>
      <div className={css.heroContainer}>
        <div className={css.heroBg}>
          <div className={css.contentWidth}>
            <div className={css.heroContent}>
              <Heading as="h1" rootClassName={css.heading}>
                {title}
              </Heading>
              <p>{description}</p>
              <div className={css.exploreSec}>
                <PrimaryButton
                  type="button"
                  className={css.exploreBtn}
                  onClick={() =>
                    useHistoryPush('SearchPage', null, { pub_listingCategory: 'talent' })
                  }
                >
                  {explore}
                </PrimaryButton>
                {!isAuthenticated && (
                  <SecondaryButton
                    type="button"
                    className={css.exploreBtn}
                    onClick={() => useHistoryPush('SignupPage')}
                  >
                    {joinLabel}
                  </SecondaryButton>
                )}
              </div>
            </div>

            {/* Video Background */}
            <div className={css.heroContentImg}>
              <video className={css.featuredVideo} autoPlay loop muted playsInline>
                <source src={sectionHeroVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
